import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private datePipe: DatePipe) { }

  selectClass(description) {
    if (description) {
      const product: string = description;
      let productClass = "";
      if (product?.toLowerCase().includes('regular') || product?.toLowerCase().includes('reg')) {
        productClass = 'regular';
      } else if (product?.toLowerCase().includes('super') || product?.toLowerCase().includes('sup')) {
        productClass = 'super';
      } else if (product?.toLowerCase().includes('plus') || product?.toLowerCase().includes('mid')) {
        productClass = 'plus';
      } else if (product?.toLowerCase().includes('uls') || product?.toLowerCase().includes('premium')) {
        productClass = 'uls';
      } else if (product?.toLowerCase().includes('red') || (product?.toLowerCase().includes('dyed'))) {
        productClass = 'dyed';
      } else {
        productClass = 'misc';
      }
      return productClass;
    }
  }

  public formatDateToSave(date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss')
  }

  
  public formatDateToDisplay(date): string {
    return this.datePipe.transform(date, 'MM-dd-yyyy hh:mm aa')
  }

  public formatDateOnly(date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }


}
